import { render, staticRenderFns } from "./GuidelinesModal.vue?vue&type=template&id=51f32870&scoped=true"
import script from "./GuidelinesModal.vue?vue&type=script&lang=ts"
export * from "./GuidelinesModal.vue?vue&type=script&lang=ts"
import style0 from "./GuidelinesModal.vue?vue&type=style&index=0&id=51f32870&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f32870",
  null
  
)

export default component.exports